<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "RAW_ALARM_DETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body">
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_ASSETTYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pt-3 pb-3 item-info">{{
          event.assetTypeName ? event.assetTypeName : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_SERVICENAME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{ event.serviceName }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_METERNO" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{ event.meterNumber }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "DEVICESETUP_METERMAKE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{ event.meterMakeName }}</span>
      </div>
    </div>
    @if(!!event.startTime){
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "STARTTIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{
          event.startTime | date: "dd MMM yyyy, h:mm a"
          }}</span>
      </div>
    </div>
    }
    <div class="row g-0 m-0">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "READTIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{
          event.readOnMeterTime | date: "dd MMM yyyy, h:mm a"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0 mb-4">
      <div class="col-md-6 ps-2 d-flex justify-content-start">
        <span class="ps-4 pt-3 pb-3 item-name">{{
          "INGESTIONTIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="pe-4 pt-3 pb-3 item-info">{{
          event.ingestionTime | date: "dd MMM yyyy, h:mm a"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      @if(event.activeAlarms?.length !== 0){
      <div class="alert-description p-3 mt-0 mb-2">
        <span class="item-name d-block pb-2">{{
          "ACTIVEALARMS" | translate
          }}</span>
        <span class="label-box-information" *ngFor="let eventName of event.activeAlarms"
          [ngStyle]="{ 'background-color': getAlertColor(eventName) }">
          {{ eventName }}
        </span>
      </div>
      }
    </div>
  </div>
  <div class="row g-0 p-3 align-items-end bordert align-to-bottom">
    <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
        }}</span>
    </div>
  </div>
</div>